import React, { Component } from 'react'
import styled from 'styled-components'
import {
  Header,
  UserContent,
  FormikForm,
  TextField,
  Button,
  Toast,
  Modal,
  FlexWrapper,
  StyledSlider,
  DefaultText,
  Icon
} from '../components'
import { Formik, Field } from 'formik'
import Cookies from 'js-cookie'
import { editProfileValidator } from '../utlis/validators'
import axios from 'axios'
import { API_URL, DOWNLOAD_URL } from '../constants'
import AvatarEditor from 'react-avatar-editor'
const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  padding-top: 20px;
  & > button {
    height: 46px;
    padding: 0 20px;
    &:first-child {
      background: #fff;
      margin-right: 25px;
    }
  }
`
const RotateTools = styled.div`
  display: flex;
  position: relative;
  padding: 4px 0;
  width: 100%;
  justify-content: space-between;
  & > div {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    padding: 0 18px;
    cursor: pointer;
  }
`

const Trash = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
  & svg {
    width: 20px;
    height: 20px;
  }
`
class EditProfile extends Component {
  state = {
    isLoading: false,
    openToast: false,
    showModal: false,
    currentFile: '',
    zoomValue: 1,
    rotateValue: 0
  }
  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({ openToast: false })
  }

  setEditorRef = editor => (this.editor = editor)
  uploadFile = async () => {
    if (this.editor) {
      const canvasScaled = this.editor.getImageScaledToCanvas()
      canvasScaled.crossOrigin = 'Anonymous'
      const dataUrl = canvasScaled.toDataURL()
      const blob = this.dataURItoBlob(dataUrl)
      const dat = new FormData()
      dat.append('file', blob)
      const { data } = await axios.post(`${API_URL}/Containers/gcapp/upload`, dat)
      const { data: userDetails } = await axios.patch(`${API_URL}/users/${Cookies.get('user_id')}`, {
        profileImage: data.result.files.file[0].name
      })
      Cookies.set('userDetails', userDetails, { path: '/', expires: 365 })
      this.setState({
        rotateValue: 0,
        currentFile: '',
        zoomValue: 1,
        showModal: false,
        newImage: data.result.files.file[0].name
      })
    }
  }
  dataURItoBlob(dataURI) {
    var binary = atob(dataURI.split(',')[1])
    var array = []
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i))
    }
    return new Blob([new Uint8Array(array)], { type: 'image/jpeg' })
  }

  handleChooseAvatar = event => {
    new Promise(resolve => {
      let input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.style.display = 'none'
      input.addEventListener('change', event => {
        this.setState({ currentFile: input.files[0] })
      })

      document.getElementById('photo-wrap').appendChild(input)

      input.click()
    })
  }

  deleteProfileImg = async () => {
    if (window.confirm('Remove profile photo?')) {
      const { data: userDetails } = await axios.patch(`${API_URL}/users/${Cookies.get('user_id')}`, {
        profileImage: null
      })
      Cookies.set('userDetails', userDetails, { path: '/', expires: 365 })
      this.setState({
        rotateValue: 0,
        currentFile: '',
        zoomValue: 1,
        showModal: false,
        newImage: ''
      })
    }
  }

  render() {
    const { isLoading, openToast, showModal, currentFile, zoomValue, rotateValue } = this.state
    return (
      <React.Fragment>
        <Header
          title={'Edit User Profile'}
          icon="arrowBack"
          onClickBack={() => this.props.history.replace('/user-profile')}
          color="#fff"
        />
        <UserContent editProfile onPhotoChange={() => this.setState({ showModal: true })} image={this.state.newImage} />
        <FlexWrapper viewPadding="30px 30px 0">
          <Formik
            enableReinitialize
            initialValues={{ name: Cookies.getJSON('userDetails').name || '', email: '' }}
            validateOnChange
            validate={editProfileValidator}
            onSubmit={async values => {
              this.setState({ isLoading: true })
              try {
                const { data } = await axios.patch(`${API_URL}/users/${Cookies.get('user_id')}`, {
                  name: values.name
                })
                this.setState({ isLoading: false, openToast: true })
                Cookies.set('userDetails', data, { path: '/', expires: 365 })
              } catch (error) {
                this.setState({ isLoading: false })
                console.log('Err', error)
              }
            }}
            render={formikBag => (
              <FormikForm>
                <Field
                  name="name"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      label="Name"
                      margin="30px 14px"
                      width="auto"
                      fontSize="18px"
                      fontColor="#124b5f"
                      required
                      error={formikBag.errors.name}
                    />
                  )}
                />
                {/* <Field
                  name="email"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      label="Email"
                      margin="30px 14px"
                      width="auto"
                      fontSize="18px"
                      fontColor="#124b5f"
                      required
                    />
                  )}
                /> */}
                {/* <FlexWrapper alignItems="center" /> */}
                <Button
                  size="small"
                  volume="filled"
                  type="submit"
                  label="Update"
                  margin={'0 0 20px 0'}
                  disabled={isLoading}
                  isLoading={isLoading}
                />
                <Button
                  size="small"
                  type="submit"
                  label="Change Password"
                  margin={'0 0 20px 0'}
                  onClick={() => this.props.history.push('/user-profile/change-password')}
                />
              </FormikForm>
            )}
          />
        </FlexWrapper>
        <Modal
          title={'Edit Photo'}
          show={showModal}
          hide={!showModal}
          padding="0px"
          viewPadding="0"
          maxHeight="490px"
          top="0"
          onClose={() => this.setState({ showModal: false })}>
          <FlexWrapper alignItems="center" style={{ background: '#000', position: 'relative' }}>
            {!currentFile ? (
              <Trash onClick={this.deleteProfileImg}>
                <Icon icon="trash" />
              </Trash>
            ) : (
              ''
            )}
            <AvatarEditor
              ref={this.setEditorRef}
              image={currentFile || `${DOWNLOAD_URL}/${Cookies.getJSON('userDetails').profileImage}`}
              width={190}
              height={190}
              border={20}
              rotate={parseFloat(rotateValue)}
              color={[0, 0, 0, 1]} // RGBA
              scale={zoomValue}
              borderRadius={300}
            />
          </FlexWrapper>
          {currentFile && (
            <React.Fragment>
              <FlexWrapper viewPadding="0px 10px" viewMargin="auto">
                <DefaultText fontWeight="600" lineHeight={1} padding={'10px 0 0 0'} color="#124b5f">
                  Zoom
                </DefaultText>
                <StyledSlider
                  min={0.1}
                  max={2}
                  step={0.01}
                  defaultValue={1}
                  value={zoomValue.toFixed(2)}
                  onChange={value => currentFile && this.setState({ zoomValue: value })}
                  padding="0"
                />
              </FlexWrapper>
              <RotateTools>
                <div onClick={() => currentFile && this.setState({ rotateValue: rotateValue - 10 })}>
                  <Icon icon={'rotateLeft'} /> Left
                </div>
                <div onClick={() => currentFile && this.setState({ rotateValue: rotateValue + 10 })}>
                  <Icon icon={'rotateRight'} />
                  Right
                </div>
              </RotateTools>
            </React.Fragment>
          )}
          <FlexWrapper viewPadding={'0 0 20px 0'} backgroundColor={'#fff'} direction="row" justifyContent="center">
            <ButtonWrap id="photo-wrap">
              <Button label="Upload" namespace="Upload Image" size="small" onClick={() => this.handleChooseAvatar()} />
              <Button
                label="Save"
                namespace="Update Photo"
                volume="filled"
                size="small"
                disabled={currentFile ? false : true}
                onClick={() => this.uploadFile()}
              />
            </ButtonWrap>
          </FlexWrapper>
        </Modal>
        <Toast open={openToast} message="Name changed successfully" onClose={this.handleClose} />
      </React.Fragment>
    )
  }
}

export default EditProfile



// WEBPACK FOOTER //
// ./src/pages/EditProfile.js